import React, { createContext, useContext } from 'react';
import AffiliateTheme from '../styles/AffiliateTheme';

// Création du contexte avec le thème affilié comme valeur par défaut
const AffiliateThemeContext = createContext(AffiliateTheme);

// Hook personnalisé pour accéder facilement au thème affilié
export const useAffiliateTheme = () => useContext(AffiliateThemeContext);

// Composant Provider pour le thème affilié
export const AffiliateThemeProvider = ({ children }) => {
  return (
    <AffiliateThemeContext.Provider value={AffiliateTheme}>
      {children}
    </AffiliateThemeContext.Provider>
  );
};

export default AffiliateThemeContext;